import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Field } from 'formik';
import cs from 'classnames';
import styled from 'styled-components';
import { I18N } from 'commons';
import v from 'scss/v';
import ErrorMessage from '../ErrorMessage';

const ShowPasswordLabel = styled.div`
`;

class PasswordSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showPassword: false,
    };

    this.handleToggleShowPassword = () => {
      const { showPassword } = this.state;
      this.setState({
        showPassword: !showPassword,
      });
    };
  }

  render() {
    const { values: { password }, errors, touched } = this.props;
    const { showPassword } = this.state;
    const hasTouched = _.has(touched, 'password');
    const hasError = _.has(errors, 'password');

    return (
      <div className="col-md-8">
        <label className="col-form-label" htmlFor="password" id="passwordLabel">
          <I18N>ssp.register.password</I18N>
          <span aria-hidden="true" className="required-star">*</span>
          <span className="sr-only"><I18N>information.label.required</I18N></span>
        </label>
        <div>
          <Field
            type={showPassword ? 'text' : 'password'}
            name="password"
            id="password"
            aria-labelledby="passwordLabel passwordTip"
            className={cs({ 'form-control': true, valid_error: hasTouched && hasError })}
            maxLength="64"
            value={password}
            autoComplete="new-password"
          />
          <ShowPasswordLabel tabIndex={0} role="button" onClick={this.handleToggleShowPassword} className="passwordshow">
            {showPassword ? <I18N>ssp.location.hide</I18N> : <I18N>ssp.location.show</I18N>}
          </ShowPasswordLabel>
        </div>
        {hasTouched && hasError
          && <ErrorMessage id="passwordDesc" aria-hidden="true">{errors.password}</ErrorMessage>}
      </div>
    );
  }
}

PasswordSection.propTypes = {
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
};

export default PasswordSection;
